import { ApiService }            from '../../app-lite/api/api.service';
import { CompanyMessagesModel }     from '../../app-lite/companies/models/company.messages';
import { EmailVerificationService } from '../../app-lite/email-verification/email-verification.service';
import { SessionService }        from '../../app-lite/sessions/session.service';

import CompanyHtml                from './company.html';
import CompanyListsHtml           from '../../app-lite/company-lists/company-lists.html';
import CompanyMessagesHtml        from './company.messages.html';
import CompanySettingsHtml        from './company.settings.html';
import SubscriptionTypeUpdateHtml from './company.subscription-type-upgrade.html';

export function CompaniesStates (
  $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller    : 'CompanyCtrl',
    controllerAs  : '$ctrl',
    name          : 'app.company',
    reloadOnSearch: false,
    templateUrl   : CompanyHtml,
    url           : '/company?first_login',
    resolve       : {
      company          : ( workshopAPI : ApiService ) => workshopAPI.get('/company'),
      countries        : ( workshopAPI : ApiService ) => workshopAPI.get('/system/country_types'),
      emailVerification: ( emailVerificationApi : EmailVerificationService ) => emailVerificationApi.checkVerificationStatus(),
      languages        : ( workshopAPI : ApiService ) => workshopAPI.get('/system/language_types/', null, 'language_types'),
      session          : ( sessionObjAPI : SessionService ) => sessionObjAPI.refresh(),
      states           : ( workshopAPI : ApiService ) => workshopAPI.get('/system/state_types/', null, 'states')
    }
  })
  .state({
    controller : 'companySettings',
    name       : 'app.company-settings',
    templateUrl: CompanySettingsHtml,
    url        : '/settings',
    resolve    : {
      company                     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      companyInvoiceSettings      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_invoice_settings'),
      companySettings             : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_settings'),
      companyVariableLabels       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_variable_field_labels'),
      counters                    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_counter_settings'),
      integrations                : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      productCostTypes            : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/product_cost_types'),
      session                     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh(),
      taxGroups                   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/tax_groups'),
      twoFactorAuthExpirationTypes: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/system/two_factor_auth_expiration_types')
    }
  })
  .state({
    controller : 'CompanyMessagesCtrl',
    name       : 'app.company-messages',
    templateUrl: CompanyMessagesHtml,
    url        : '/messages',
    resolve    : {
      companyMessages: ( $rootScope : any ) : ng.IPromise<CompanyMessagesModel> => $rootScope.Company.getDefaultMessages(),
      session        : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  })
  .state({
    controller : 'subscriptionTypeUpgradeCtrl',
    name       : 'app.subscription-type-upgrade',
    templateUrl: SubscriptionTypeUpdateHtml,
    url        : '/subscription_type_upgrade',
    resolve    : {
      company: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company'),
      session: ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  })
  .state({
    controller : 'CompanyListsCtrl',
    name       : 'app.company-lists',
    templateUrl: CompanyListsHtml,
    url        : '/company-lists',
    resolve    : {
      customerSources     : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/customer_sources'),
      documentTemplates   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'document', '*']),
      emailTemplates      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'email', '*']),
      invoiceNoteTemplates: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'invoice', '*']),
      jobCardTemplates    : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'job_card', '*']),
      paymentMethods      : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/invoice_payment_methods'),
      productCategories   : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/product_categories/product_category_list', 'false'),
      productGroups       : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/product_groups'),
      smsTemplates        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'sms', '*']),
      unitForSaleTemplates: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/templated_wordings', [ 0, '*', 'description', 'asc', 'unit', '*'])
    }
  });
};